/**
 * Global loading overlay component with spinner and opacity film
 */

import { Spinner } from "./ui/spinner";
import { cn } from "../lib/utils";

interface GlobalLoadingOverlayProps {
  isLoading: boolean;
}

export function GlobalLoadingOverlay({ isLoading }: GlobalLoadingOverlayProps) {
  if (!isLoading) return null;

  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center",
        "bg-surface-default/80 backdrop-blur-sm",
        "transition-opacity duration-300"
      )}
      role="dialog"
      aria-modal="true"
      aria-label="Loading"
    >
      <div className="flex flex-col items-center space-y-4">
        {/* Pinwheel Spinner */}
        <div className="relative">
          <Spinner variant="pinwheel" size={48} className="text-brand-secondary" />
        </div>

        {/* Loading Text */}
        <p className="text-text-primary text-lg font-medium">Loading...</p>
      </div>
    </div>
  );
}
